'use client';
import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';
import {useTranslation} from 'react-i18next';
import {BaseModal} from '../primitives';
import {NearbyPlaceRow, type NearbyPlaceRowProps} from './NearbyPlaceRow';

export interface NearbyModalProps {
  open: boolean;
  onClose: () => void;
  places: NearbyPlaceRowProps[];
}

// Two columns on desktop and mobile alike — the Figma "Facilities drawer" keeps
// a 2-up grid even on phones.
const Grid = styled(Box)(({theme}) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  rowGap: theme.spacing(2),
  columnGap: 0,
  '& > *': {
    paddingBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.colors.border.neutral.default}`,
  },
  '& > *:nth-child(odd)': {paddingInlineEnd: theme.spacing(1)},
  '& > *:nth-child(even)': {paddingInlineStart: theme.spacing(1)},
  '& > *:nth-last-child(-n + 2):nth-child(odd), & > *:nth-last-child(-n + 2):nth-child(odd) ~ *': {
    borderBottom: 'none',
    paddingBottom: 0,
  },
}));

export function NearbyModal({open, onClose, places}: NearbyModalProps) {
  const {t} = useTranslation();

  return (
    <BaseModal open={open} onClose={onClose} title={t('whats_nearby')} maxWidth={720} fadeOverflow>
      <Grid>
        {places.map((place, index) => (
          <NearbyPlaceRow key={`${place.label}-${index}`} {...place} />
        ))}
      </Grid>
    </BaseModal>
  );
}

NearbyModal.displayName = 'NearbyModal';
